import { PropsWithChildren } from 'react';
import { CatHeading } from '@blocks-react/components/Heading';
import { CatGridItem } from '@blocks-react/components/GridItem';

import styles from '../Footer.module.scss';

interface FooterColumnProps {
  name: string;
}

export const FooterColumn = ({
  name,
  children
}: PropsWithChildren<FooterColumnProps>) => (
  <CatGridItem>
    <div
      className={`${styles['footer-links__column']}`}
      data-testid="footerColumnTestId"
    >
      <CatHeading
        variant="title-sm"
        color="knockout"
        level="h6"
        aria-label={name}
      >
        {name}
      </CatHeading>
      <ul className={`${styles['footer__list']}`}>{children}</ul>
    </div>
  </CatGridItem>
);
